<ng-container *ngIf="expertGroupPortal">
  <div class="container-full bg-theme">
    <div class="container">
      <div class="columns">
        <div class="column is-12 p-b-xl">
          <div
            class="temporary-item temporary-breadcrumbs"
            *ngIf="!breadcrumbLinks"
          ></div>
          <app-breadcrumbs
            [breadcrumbLinks]="breadcrumbLinks"
            [darkTheme]="true"
          ></app-breadcrumbs>
          <div>
            <h1 class="title is-1 has-text-light">
              {{ expertGroupPortal.title }}
            </h1>
            <p class="subtitle has-text-light m-y-gutter">
              {{ expertGroupPortal.subtitle }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-full">
    <div class="subnav has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column py-4">
            <div class="full-width subnav--list" *ngIf="!loading">
              <a
                id="overview"
                class="button is-small is-white"
                [routerLink]="expertGroupPortal.baseUrl"
                [ngClass]="{ 'is-active': selectedNavItem === 'overview' }"
                >Overview</a
              >
              <a
                id="discussions"
                class="button is-small is-white"
                *ngIf="hasDiscussions"
                [routerLink]="expertGroupPortal.baseUrl + '/discussions'"
                [ngClass]="{ 'is-active': selectedNavItem === 'discussions' }"
                >Discussions</a
              >
              <a
                id="data"
                class="button is-small is-white"
                *ngIf="hasData"
                [routerLink]="expertGroupPortal.baseUrl + '/data'"
                [ngClass]="{ 'is-active': selectedNavItem === 'data' }"
                >Data</a
              >
              <a
                id="experts"
                class="button is-small is-white"
                [routerLink]="expertGroupPortal.baseUrl + '/experts'"
                [ngClass]="{ 'is-active': selectedNavItem === 'experts' }"
                >Experts</a
              >
              <a
                id="resources"
                class="button is-small is-white"
                [routerLink]="expertGroupPortal.baseUrl + '/publications'"
                [ngClass]="{ 'is-active': selectedNavItem === 'resources' }"
                >Resources</a
              >
              <div
                *ngIf="expertGroupPortal.id === 'incidents'"
                class="is-inline-flex is-full-height is-align-items-center is-justify-content-center ml-6 is-hidden-mobile"
              >
                <a
                  class="button is-warning has-text-weight-bold"
                  routerLink="/incidents"
                >
                  AI Incidents Monitor (AIM)</a
                >
              </div>
            </div>

            <!-- Loader -->
            <div class="full-width subnav--list" *ngIf="loading">
              <a class="button is-small is-white lc--subnav">
                <span></span>
              </a>
              <a class="button is-small is-white lc--subnav">
                <span></span>
              </a>
              <a class="button is-small is-white lc--subnav">
                <span></span>
              </a>
              <a class="button is-small is-white lc--subnav">
                <span></span>
              </a>
              <a class="button is-small is-white lc--subnav">
                <span></span>
              </a>
              <a class="button is-small is-white lc--subnav">
                <span></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
